<template>
  <div>
      <section class="page-title" style="background-color:#e2f1f2;">
          <div class="center">
              <v-layout row wrap>
                  <v-flex xs12 sm12 lg8>
                      <p class="label-planos">PROGRAMA DE BENEFÍCIOS - AUXÍLIO ODONTOLÓGICO</p>
                      <h1 class="the-title">2ª Via de Contrato</h1>
                      <h1 class="the-title" style="font-size:30px">Servidor da Prefeitura de São Paulo</h1>
                  </v-flex>
              </v-layout>                   
          </div>
      </section>

      <section class="page-content center">
          <v-layout row wrap>        
              <v-flex xs12 sm12 lg11>
                  <div class="app-container">
                      <h1>Servidor da Prefeitura de São Paulo</h1>
                      <p>Digite aqui o seu CPF e acesse a 2ª via do seu contrato.</p>

                      <!-- Corrigido a tag de abertura do div -->
                      <div v-if="!isContractFound">
                          <div class="buttons">
                              <input
                                  v-mask="'###.###.###-##'"
                                  v-model="cpfInput"
                                  placeholder="Digite seu CPF"
                                  @input="updateCpf"
                              />
                          </div>
                          <div class="buttons">
                              <button @click="searchContract">Buscar</button>
                              <button @click="clearInput">Limpar</button>
                          </div>
                      </div>

                      <!-- Seção para exibir se o contrato foi encontrado -->
                      <div v-if="isContractFound">
                          <p>Contrato {{ maskedCpf }} localizado.</p>
                          <button @click="downloadContract">Download</button>
                          <button @click="newSearch">Nova Busca</button>
                      </div>

                      <!-- Seção para exibir se o contrato não foi encontrado -->
                      <div v-if="isNotFound">
                          <p>Contrato não encontrado. Verifique o CPF digitado.</p>
                          <button @click="newSearch">Nova Busca</button>
                      </div>
                  </div>
              </v-flex>
          </v-layout>              
      </section>
  </div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
export default {
  components: { Snackbar },
  data() {
      return {
          contrataccept: false,
          dialog: false,
          matricula: '',
          dictionary: {          
              custom: {
                  carteirinha: {
                      required: () => 'Informe o número da carteirinha'
                  }
              }
          }
      }
  },

  mounted() {
      this.$store.dispatch('EscondeToolbar')
      this.$store.dispatch('EscondeFooter')
      this.$validator.localize('pt', this.dictionary)
      localStorage.clear()
      sessionStorage.clear()
  },

  watch: {
      dialog(val) {
          val || this.close()
      }
  },

  methods: {
      openDialog() {
          this.dialog = true
      }
  }
}
</script>

<script>
export default {
  data() {
      return {
          cpfInput: '',
          cpf: '',
          isContractFound: false,
          isNotFound: false,
          contractUrl: '',
      };
  },
  methods: {
      updateCpf() {
          this.cpf = this.cpfInput.replace(/\D/g, ''); // Remove pontuações
      },
      searchContract() {
          this.isContractFound = false;
          this.isNotFound = false;
          this.contractUrl = `https://www.primavida.com.br/emkt/contratosprefeiturasp/${this.cpf}.pdf`;

          // Abre a URL em uma nova aba
          window.open(this.contractUrl);
          this.isContractFound = true;
      },
      clearInput() {
          this.cpfInput = '';
          this.cpf = '';
      },
      newSearch() {
          this.isContractFound = false;
          this.isNotFound = false;
          this.clearInput();
      },
      maskedCpf() {
          return `${this.cpf.slice(0, 3)}.***.***-${this.cpf.slice(9)}`;
      },
      downloadContract() {
          window.open(this.contractUrl); // Abre a URL em uma nova aba
      }
  },
};
</script>

<style>
.link {
  font-size: 1.3rem;
  color: #194383;
  text-align: center;
}

.titulo {
  font-size: 2rem;
  color: #797a7a;
  text-align: center;
}

.tabela {
  border-collapse: separate;
  border-spacing: 2;
}

.app-container {
  text-align: center;
  padding: 20px;
}

input {
  width: 200px;
  padding: 8px;
  margin: 10px;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

button {
  padding: 10px 20px;
  margin: 5px;
}

.localizacao {
  border: 1px solid;
  border-color: #009b9b;
}

.planos-wrapper .list-planos .item .priceOld {
  margin-bottom: -10px;
  font-weight: 700;
  font-size: 30px;
  line-height: 34px;
  color: #009b9b;
  text-align: center;
  text-decoration: line-through;
}

.planos-wrapper .list-planos .item .priceOld span {
  margin-bottom: -10px;
  font-size: 15px;
  font-weight: 300;
  color: #666;
  position: relative;
  top: -15px;
  margin-right: -5px;
}

.dePara {
  margin-bottom: -10px;
  font-weight: 400;
  font-size: 15px;
  line-height: 37px;
  color: #009b9b;
  text-align: center;
}

.planos-wrapper .list-planos .item .price {
  margin-bottom: -5px;
  font-weight: 700;
  font-size: 45px;
  line-height: 37px;
  color: #009b9b;
  text-align: center;
}

.desconto {
  text-align: center;
  margin-bottom: 5px;
  font-size: 15px;
  font-weight: 300;
  color: #666;
  position: relative;
  top: -15px;
  margin-right: -10px;
}
</style>
